import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=21c71fa6&scoped=true&"
import script from "./baseEdit.vue?vue&type=script&lang=js&"
export * from "./baseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c71fa6",
  null
  
)

export default component.exports